// v2/hooks/useAdminOverview.js — /api/v2/admin/overview/
// yenile(true) sunucu onbellegini atlar. Sekme gorunurken 2 dk'da bir tazelenir.
import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet } from '../utils/api';

const OTOMATIK_MS = 120 * 1000;

function duzenle(v) {
  const q = v.queue || {};
  const g = v.logins || {};
  return {
    ...v,
    kpis: v.kpis || {},
    cart: v.cart || {},
    users: v.users || {},
    restrictions: v.restrictions || {},
    series: Array.isArray(v.series) ? v.series : [],
    top_customers: Array.isArray(v.top_customers) ? v.top_customers : [],
    recent_orders: Array.isArray(v.recent_orders) ? v.recent_orders : [],
    queue: { ...q, error_items: Array.isArray(q.error_items) ? q.error_items : [] },
    logins: { ...g, recent: Array.isArray(g.recent) ? g.recent : [] },
  };
}

export default function useAdminOverview() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const yenile = useCallback(async (zorla = false) => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    try {
      const yol = `/v2/admin/overview/${zorla === true ? '?refresh=1' : ''}`;
      const veri = await apiGet(yol, { signal: ctrl.signal });
      if (ctrl.signal.aborted) return;
      if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Veriler alınamadı');
      setData(duzenle(veri));
    } catch (e) {
      if (e && e.name === 'AbortError') return;
      // onceki veri ekranda kalir, sadece hata bilgisi guncellenir
      setError((e && e.message) || 'Veriler alınamadı');
    } finally {
      if (!ctrl.signal.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    yenile();
    const zamanlayici = setInterval(() => {
      if (typeof document === 'undefined' || !document.hidden) yenile();
    }, OTOMATIK_MS);
    return () => {
      clearInterval(zamanlayici);
      if (abortRef.current) abortRef.current.abort();
    };
  }, [yenile]);

  return { data, loading, error, yenile };
}
